import { render } from "./ChampionOverview.vue?vue&type=template&id=c68dcf86&scoped=true"
import script from "./ChampionOverview.vue?vue&type=script&lang=ts"
export * from "./ChampionOverview.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-c68dcf86"

export default script